window.addEventListener("load", () => {
    document.querySelectorAll(".tx-wp-donation").forEach((element) => {
        WpFormHandler.initOnContainer(element);
    });
});